:host {
  --font-color: #606266;
  --active-font-color: #409eff;
  --disable-font-color: #c0c4cc;
  --background-color: #fff;
  --active-background-color: #ecf5ff;
  --border-color: #ebeef5;
  --container-padding: 8px 0;
}

// 滚动条宽度
:host::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: transparent;
}

// 滚动槽
:host::-webkit-scrollbar-track {
  border-radius: 5px;
  box-shadow: none;
  border: 0;
}

// 滚动条滑块
:host::-webkit-scrollbar-thumb {
  border-radius: 5px;
  box-shadow: none;
  border: 0;
  background-color: rgba($color: #000000, $alpha: 0.3);
}

:host(.context-menu-container) {
  position: absolute;
  box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
  background: var(--background-color);
  border-radius: 4px;
  z-index: 1000;
  min-width: 230px;
  overflow-x: hidden;
  overflow-y: auto;

  .context-menu {
    margin: 0;
    padding: var(--container-padding);
  }

  .context-menu-item-line {
    margin: 3px 0;
    border-bottom: 1px solid var(--border-color);
  }

  .context-menu-item {
    display: flex;
    cursor: pointer;
    align-items: center;
    color: var(--font-color);
    fill: var(--font-color);
    list-style: none;
    line-height: 24px;
    padding: 0 10px;
    margin: 0;
    font-size: 12px;
    outline: 0;
    transition: 0.2s;
  }

  .context-menu-item.disable {
    fill: var(--disable-font-color);
    color: var(--disable-font-color);
    cursor: not-allowed;
    background: transparent;
  }

  .context-menu-item.enable:hover {
    background: var(--active-background-color);
    color: var(--active-font-color);
  }

  .context-menu-item.embed-icon {
    display: block;
    padding: 0 30px;
  }

  .embed-icon {
    .context-menu-icon {
      --font-size: 20px;
    }
  }

  .embed-icon--header {
    height: 20px;
  }

  .embed-icon--items {
    display: flex;
  }

  .embed-icon--item {
    margin-right: 6px;
  }

  .embed-icon--item:hover {
    background: var(--active-background-color);
    color: var(--active-font-color);
  }

  .menu-item-icon,
  .menu-item-expand-icon {
    flex-shrink: 0;
    text-align: center;
    width: 14px;
    display: flex;
    align-items: center;
  }

  .menu-item-label {
    flex-grow: 1;
    padding: 0 6px;

    .label-left {
      float: left;
    }

    .label-right {
      float: right;
    }
  }
}
